import { CompanysitesService } from '../../company-sites/company-sites.service';
import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { ReportGeneratorService } from '../report-generator.service';
import { ActivatedRoute } from '@angular/router';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SystemService } from '../../../services/system.service';
import { ProductService } from '../../product/product.service';
@Component({
  selector: 'app-report-generator-result',
  templateUrl: './report-generator-result.component.html',
  styleUrls: ['./report-generator-result.component.css']
})
export class ReportGeneratorResultComponent implements OnDestroy {
  @ViewChild('table', { static: false }) table: ElementRef;
  dataSource$: Observable<MatTableDataSource<any>>;
  filter$: Subject<string>;
  dataSource;
  columnSettings$: Observable<ColumnSetting[]>;

  siteName: string;
  systemName: string;
  employee: string;
  product: string;
  dateFrom: string;
  dateTo: string;
  forceLoading: boolean = true;
  forceLoading$: Observable<boolean>;
  values$: Observable<any>;
  siteData$: Observable<any>;
  siteDataSub: Subscription;
  sortingArray = []
  constructor(private productService: ProductService, private systemService: SystemService, private reportService: ReportGeneratorService, private route: ActivatedRoute, private siteService: CompanysitesService) {


    let params = this.route.snapshot.queryParams;

    this.siteData$ = this.siteService.getSiteById(params['siteId']).pipe(map(value => {
      return {
        name: value.data()['name'],
        siteId: params['siteId'],
        isDepartmentActive: value.data()['isDepartmentActive'],
        isProjectActive: value.data()['isProjectActive'],
        isFreetextActive: value.data()['isFreetextActive'],
        strictGroup: value.data()['strictGroup'],
      };
    }))

    let focusBy = params['focusBy'];

    this.columnSettings$ = this.siteData$.pipe(map(siteData => {
      let columnSettings;
      if (focusBy == 'BYPRODUCT') {
        columnSettings = [
          {
            columnId: 'productName',
            name: 'Product Name',
            maxLengthOnMobile: 10,
          }, {
            columnId: 'channelId',
            name: 'Product Name',
            maxLengthOnMobile: 10,
          },
          {
            columnId: 'systemName',
            name: 'System Name',
            hideOnMobile: true
          },
          {
            columnId: 'qty',
            name: 'Quantity',
          },
          
          {
            columnId: 'price',
            name: 'Price',
          },
        ]
        this.sortingArray = ['Product Name', 'Product #', 'System Name', 'Quantity', 'Str. Qty.', 'Date', 'OrderId']

      } else if (focusBy == 'ALL') {
        columnSettings = [

          {
            columnId: 'productName',
            name: 'Product Name',
            class: "mobile"
          }
          ,
          {
            columnId: 'systemName',
            name: 'System Name',
            hideOnMobile: true,
            class: "mobile"
          },
          {
            columnId: 'date',
            name: 'Date',
            hideOnMobile: true,
            class: "mobile"
          },
          {
            columnId: 'orderID',
            name: 'OrderId',
            class: "mobile"
          },
          {
            columnId: 'payType',
            name: 'Type',
            class: "mobile"

          }, {
            columnId: 'discount',
            name: 'Subsidy',
            class: "mobile"
          },
          {
            columnId: 'price',
            name: 'Price',
            class: "mobile"
          },
          {
            columnId: 'pant',
            name: 'Pant',
            class: "mobile"
          },
           {
            columnId: 'userName',
            name: 'User',
            class: "mobile"

          }, {
            columnId: 'subsidized',
            name: 'Subsidized',
            class: "mobile"
          },
          {
            columnId: 'mva',
            name: 'vat',
            class: "mobile"
          }, {
            columnId: 'category',
            name: 'category',
            class: "mobile"
          },
          {
            columnId: 'salepriceWithoutMVA',
            name: 'salepriceWithoutMVA',
            class: "mobile"

          },
          {
            columnId: 'status',
            name: 'Status',
            class: "mobile"
          }

        ]
        this.sortingArray = ['Product Name', 'User', 'System Name', 'Quantity', 'Date', 'OrderId', 'Type', 'Subsidy', 'salepriceWithoutMVA', 'Group', "Subsidized", 'Status', 'Price', 'Pant']

      }
      return columnSettings;
    }))

    if (focusBy == 'BYEMPLOYEE') {
      this.values$ = this.reportService.getData(params)
    } else if (focusBy == 'BYPRODUCT') {
      this.values$ = this.reportService.getDataByProduct(params);
    } else if (focusBy == 'ALL') {
      this.values$ = this.reportService.getAll(params)
    }
    this.values$.subscribe(data => {
      data.forEach(async element => {
        // if (element.extraInfo != null && JSON.parse(element.extraInfo)?.isKampanje){
          // element.discountedPrice = element.discountedPrice + (element.discountedPrice * (0.3 / 0.7));
          // console.log(element.orderID,(element.price),Number(element.discountedPrice).toFixed(2))
          //  this.systemService.updateTranaction(element['dbid'],{price:Number(element.discountedPrice),salepriceWithoutMVA:Number(element.discountedPrice),salePriceIncSubsidy:Number(element.discountedPrice) })


        // if(element.price == null ) {
        //   console.log(element.productId);
        //   // let product = await this.productService.getProductById(element.productId);
        //   console.log(element);
        //   let obj = {
        //     price : product['price'],
        //   salepriceWithoutMVA: Number((product['price'] / (1 + Number(product['vat']) / 100)).toFixed(2)),
        //   mvaPrice: Number((product['price'] - (product['price'] / (1 + (Number(product['vat']) / 100)))).toFixed(2)),
        //   subsidizedExVAT: Number((product['price'] / (1 + (Number(product['vat']) / 100)) * (Number(50) / 100)).toFixed(2)),
        //   salePriceIncSubsidy: Number((product['price'] - (product['price'] * (Number(50) / 100))).toFixed(2)),
        //   }
        //   console.log(obj)
        // }
        //  this.systemService.updateTranaction(element['dbid'],{price:element['price']*2})
        // this.systemService.updateTranaction(element['dbid'],obj)

      });
    })
  }
  ngOnDestroy(): void {
    if (this.siteDataSub) this.siteDataSub.unsubscribe();
  }


}
